import React from 'react';
import { useCustomer } from 'hooks/context/customer/customer';
import { useMerchantState } from 'hooks/context/MerchantState';
import { AuthenticationRoute } from 'routes/Authentication/Authentication';
import { RouteFC } from 'util/routeTypes';

export const CheckoutAuthentication: RouteFC = () => {
  const { isLoggedIn } = useCustomer();
  const { showCustomerAuthState } = useMerchantState();

  if (!showCustomerAuthState && isLoggedIn) return null;

  return <AuthenticationRoute />;
};
